// extracted by mini-css-extract-plugin
module.exports = {"container":"UserHasBidOrOffered_container__Pqps2"};